<template>
  <div class="page">
    <v-touch @swipeleft="doNext" @swiperight="doPrev" :swipe-options="{threshold:50,direction: 'horizontal'}" class="v-touch">
      <template v-for="(que,idx) in questions">
      <div :class="['que-panel',{'active':active === idx}]" v-if="active===idx" :key="que.id">
        <div class="question" >
          <div class="title">
            <tag :type="['primary','success','warning','info','danger'][que.type]" plain>{{ types[que.type] }}</tag>
            <span>{{idx+1}}、</span>
            <div v-html="que.title" style="display: inline"></div>
          </div>

          <div class="options" v-if="que.type<2">
            <div :class="['item',{'right': isRight(que,i) },{'error': isError(que,i)}]" v-for="(option,i) in que.optionList" :key="i" @click="doSelect(que,option,i)">
              <span class="letter">{{ String.fromCharCode(65+i)}}</span>
              <span class="name" v-html="option.title"></span>
            </div>
          </div>

          <div class="input-area" v-if="que.type == 4">
            <field v-model="que.selected" rows="5" autosize type="textarea" placeholder="请填写您的答案" />
          </div>
        </div>

        <div class="answer" v-if="que.selected">
          <div class="sign" v-if="que.selected && que.type<2">
            <span class="title">正确答案：</span>
            <span class="letter success">{{ que.answer }}</span>
          </div>
          <div class="sign" v-if="que.selected && que.type<2">
            <span class="title">您的答案：</span>
            <span class="letter" :class="que.answer.includes(ans) ? 'success':'error'" v-for="(ans,k) in (que.selected.split(','))" :key="k"><i v-if="k!=0">,</i>{{ans}}</span>
          </div>
          <div class="analysis" v-if="que.analysis && que.right != undefined">
            <div class="title" v-if="que.analysis">解析</div>
            <div class="desc"  v-if="que.analysis" v-html="que.analysisType == 1?que.analysis:formatText(que.analysis)"></div>
            <div class="title" v-if="que.chapterTitle">知识点</div>
            <div class="desc"  v-if="que.chapterTitle">{{ que.chapterTitle }}</div>
          </div>
        </div>

        <div class="manipulate">
          <van-button round plain type="info" size="small" class="prev" icon="arrow-left" @click="doPrev">上一题</van-button>
          <van-button round plain type="info" size="small" class="next" icon="success" @click="doSubmit(que,idx)" v-if="que.type==1 && !que.selected">提交</van-button>
          <van-button round plain type="info" size="small" class="next" icon="arrow" icon-position="right" @click="doFinish" v-else-if="active == questions.length-1 && questions.length == activeNum">提交</van-button>
          <van-button round plain type="info" size="small" class="next" icon="arrow" icon-position="right" @click="doNext" v-else-if="active != questions.length-1">下一题</van-button>
        </div>
      </div>
      </template>
    </v-touch>
    <div class="footer">
      <div class="star" @click="doStore(questions[active])">
<!--        <icon name="star" size="20px" color="#FA9D3B" v-if="questions[active] && questions[active].star" />-->
<!--        <icon name="star-o"  size="20px" v-else />-->
      </div>
      <div class="tools" @click="toSheet">
<!--        <div class="item success-num"><icon name="checked" size="20px" color="#1abb1d" />{{rightNum}}</div>-->
<!--        <div class="item error-num"><icon name="clear" size="20px" color="#e93323" />-->
<!--          {{ errorNum }}</div>-->
        <div class="item que-num"><icon name="apps-o" size="20px" />{{active+1}}/{{ questions.length }}</div>
      </div>
    </div>

    <popup v-model="answerSheet"  position="bottom" :style="{ height: '50%' }" class="answer-sheet">
      <div class="header">答题卡</div>
      <div class="status-bar">
        <div class="actv">当前</div>
        <div class="undo">未做</div>
        <div class="right">正确</div>
        <div class="error">错误</div>
      </div>
      <div class="que-idx-list">
        <div :class="['item',{'active':active === idx}]" v-for="(que,idx) in questions" :key="idx" @click="jump(idx)">{{idx+1}}</div>
      </div>
    </popup>
  </div>
</template>
<script>
import { getLibWrong } from "@api/exam";
import { Tag, Icon, Button as VanButton, Popup,Field, Toast } from "vant";
import { decrypt } from "@utils/crypto";

export default {
  components: {
    Tag,Icon,VanButton,Popup,Toast,Field
  },
  data: function() {
    return {
      answerSheet:false,
      questions: [],
      records: [],
      types: ['单选题','多选题','判断题','填空题','问答题'],
      active:0,
      id: this.$route.params.id,
      starNum:0,
      rightNum:0,
      errorNum:0,
      activeNum:0
    };
  },
  created() {
    this.init();
  },
  methods: {
    toSheet(){
      this.answerSheet = true
    },
    init(){
      Toast.loading({ duration: 0,forbidClick: true,message:'加载中...'})
      getLibWrong(this.id).then(res => {
        let result = JSON.parse(decrypt(res.result))
        this.questions = result.quesions || []
        this.records = result.answer || []

        let ansmap = this.records.reduce((r, i) => (r[i.id] = i, r), {})
        this.questions.forEach(o=> {
          if(ansmap[o.id]){
            Object.assign(o,ansmap[o.id])
          }
        })
        Toast.clear()
      })

    },
    doSelect(que,option,idx){
      console.info(que,option,idx)
    },
    isRight(que,idx){
      if(que.type == 1 && !que.selected && que.multiple && que.multiple.includes(String.fromCharCode(65+idx)) ){         //多选题没做完，默认是正确的
        return true
      }else{
        return que.selected && que.answer.includes(String.fromCharCode(65+idx))
      }
    },
    isError(que,idx){
      return que.selected && que.selected.includes(String.fromCharCode(65+idx)) && !que.answer.includes(String.fromCharCode(65+idx))
    },
    jump(idx){
      this.active = idx
      this.answerSheet = false
    },
    doStore(que) {
      this.$set(this.questions,this.active,Object.assign(que,{'star':!que.star}))
    },
    doNext() {
      if((this.active+1) < (this.questions.length)){
        this.active++
      }
    },
    doPrev() {
      if(this.active > 0){
        this.active--
      }
    },
    formatText(text){
      if(text){
        return text.replace(/\n/g,"<br/>");
      }else{
        return text
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.page {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #F5F5F5;

  .que-panel{
    height: calc(100vh - 50px);
    overflow-y: auto;
    display: none;
    &.active{
      display: block;
    }
  }

  .question {
    padding:20px 15px;
    background-color: #ffffff;
    margin-bottom: 20px;
    font-size: 12px;
    min-height: 200px;

    ::v-deep .van-tag{
      font-size: 12px;
      margin-right: 5px;
      font-weight: 400;
    }

    .title{
      margin-bottom: 15px;
      line-height: 24px;
      font-size: 14px;
      font-weight: 700;

      ::v-deep p:first-child{
        display: inline;
      }
      ::v-deep img{
        max-width: 100%;
      }
    }

    .options{
      .item{
        padding: 10px 8px;
        background-color: #f7f7f7;
        border:1px solid #f7f7f7;
        border-radius: 4px;
        margin:12px 0;
        display: flex;
        align-items: center;

        &.right{
          border:1px solid #799a74;
          background-color: #e9fde1;
        }
        &.error{
          border:1px solid #ca4848;
          background-color: #ffd9db;
        }

        .letter{
          margin: 0 10px;
        }
        .name{
          margin-left: 5px;
        }
      }
    }
    .input-area{
      background-color: #f7f7f7;
      border:1px solid #e6e6e6;
      border-radius: 2px;
    }
  }

  .answer {
    padding:10px 15px;
    background-color: #fff;
    min-height: 160px;

    .sign{
      margin:8px 0;
      font-size: 12px;

      .title{
        margin-right: 10px;
      }

      .letter{
        &.success{
          color:#1abb1d;
        }
        &.error{
          color:#e93323;
        }
      }
    }

    .analysis{
      //border-top: 1px solid #f3f3f3;
      //margin-top: 15px;
      padding: 10px 0;
      color: #696969;
      font-size: 12px;

      .title{
        margin:10px 0 5px;
        font-weight: 700;
        font-size: 12px;

        &:before{
          content: ' ';
          border-left: 3px solid #00aaea;
          height: 10px;
          display: inline-block;
          margin-right: 5px;
        }
      }
      .desc{
        line-height: 22px;
        color:#3c3c3c;
        margin-bottom: 20px;
      }
    }

  }

  .manipulate{
    margin:30px 0;
    padding:0 30px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .prev{
      padding: 0 25px 0 20px;
    }
    .next{
      padding: 0 20px 0 25px;
    }
  }

  .footer{
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: content-box;
    height: 50px;
    background-color: #fff;
    padding:0 10px;
    box-sizing: border-box;

    .tools{
      display: flex;
      align-items: center;
      vertical-align: middle;
      justify-content: space-around;

      .item{
        display: flex;
        align-items: center;
        margin:0 8px;
        i{
          margin-right: 5px;
        }
        &.que-num{
          margin-right: 0;
        }
      }

    }
  }

  .answer-sheet{
    font-size: 12px;

    .header{
      font-size: 14px;
      font-weight: 700;
      padding: 10px 0 ;
      text-align: center;
    }
    .status-bar{
      height: 42px;
      background-color: #f7f7f7;
      display: flex;
      align-items: center;
      padding: 0 10px;

      .actv{
        margin-right: 15px;
        &:before{
          content: ' ';
          border: 1px solid #00aaea;
          display: inline-block;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }
      .undo{
        margin-right: 15px;
        &:before{
          content: ' ';
          border:1px solid #ccc;
          display: inline-block;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }
      .right{
        margin-right: 15px;
        &:before{
          content: ' ';
          border:1px solid #799a74;
          background-color: #e9fde1;
          display: inline-block;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }
      .error{
        margin-right: 10px;
        &:before{
          content: ' ';
          border:1px solid #ca4848;
          background-color: #ffd9db;
          display: inline-block;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }

    }
    .que-idx-list{
      display: flex;
      flex-wrap: wrap;
      padding: 10px 5px;

      .item{
        display: flex;
        justify-content: center;
        align-items: center;
        margin:8px 10px;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        border:1px solid #ccc;

        &.right{
          border:1px solid #1abb1d;
          background-color: #e9fde1;
          color:#1abb1d;
        }
        &.error{
          border:1px solid #ca4848;
          background-color: #ffd9db;
          color:#ca4848;
        }
        &.active{
          border:1px solid #00aaea;
          color:#00aaea;
        }
      }

    }
  }

}
</style>
